import { render, staticRenderFns } from "./spaceInformation.vue?vue&type=template&id=27da06ba"
import script from "./spaceInformation.vue?vue&type=script&lang=js"
export * from "./spaceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports